module.exports = __webpack_public_path__ + "static/media/sell100-icon.4cca5636.png";